module.exports = __webpack_public_path__ + "img/banner.a49775cc.jpg";